// src/pages/Connector/OneDrive/SyncSettingsModalForDrive.js
import React, { useState, useEffect } from "react";
import { Modal as MuiModal, Box, Button as MuiButton, TextField, Checkbox, FormControlLabel } from '@mui/material';

export default function SyncSettingsModalForDrive({ isOpen, onClose, onSave, document, isLoading, permission}) {
    const [isAutoSync, setIsAutoSync] = useState(document?.is_auto_sync ?? false);
    // Use default_interval_days from document if sync_interval_days is not set or 0
    const [syncInterval, setSyncInterval] = useState(
        (document?.sync_interval_days && document.sync_interval_days > 0) 
        ? document.sync_interval_days.toString() 
        : (document?.default_interval_days ? document.default_interval_days.toString() : '7') // Fallback to 7 if default not present
    );

    useEffect(() => {
        setIsAutoSync(document?.is_auto_sync ?? false);
        const effectiveInterval = (document?.sync_interval_days && document.sync_interval_days > 0)
                                ? document.sync_interval_days 
                                : (document?.default_interval_days || 7); // Fallback
        setSyncInterval(effectiveInterval.toString());
    }, [document]);

    const handleSaveSettings = () => {
        const intervalVal = parseInt(syncInterval, 10);
        onSave({
            is_auto_sync: isAutoSync,
            // Send null if interval is invalid or user clears it, so backend can use its default
            sync_interval_days: (syncInterval === '' || isNaN(intervalVal) || intervalVal <= 0) ? null : intervalVal
        });
    };

    const modalStyle = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 500, bgcolor: 'background.paper', boxShadow: 24, p: 3, borderRadius: '8px', outline: 'none'
    };

    return (
        <MuiModal open={isOpen} onClose={onClose} aria-labelledby="onedrive-sync-settings-title">
            <Box sx={modalStyle}>
                <h5 id="onedrive-sync-settings-title" style={{ marginTop: 0, marginBottom: '20px' }}>Sync Settings for:</h5>
                <p style={{ wordBreak: 'break-all', marginBottom: '20px', fontSize: '0.9em', background: '#f9f9f9', padding: '8px', borderRadius: '4px' }}>
                    {document?.filename || "Selected File"}
                </p>
                
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={isAutoSync}
                            onChange={(e) => setIsAutoSync(e.target.checked)}
                        />
                    }
                    label="Enable Automatic Sync"
                    style={{ marginBottom: '15px' }}
                />
                <TextField
                    id="onedriveSyncInterval"
                    label="Sync Interval (days)"
                    type="number"
                    placeholder={`Default (${document?.default_interval_days || 7} days)`}
                    value={syncInterval}
                    onChange={(e) => setSyncInterval(e.target.value)}
                    disabled={!isAutoSync}
                    InputProps={{ inputProps: { min: 1 } }}
                    fullWidth
                    helperText={`Leave blank or 0 to use global default of ${document?.default_interval_days || 7} days. Active if auto-sync is ON.`}
                    variant="outlined"
                />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '25px' }}>
                    <MuiButton variant="outlined" onClick={onClose}>Cancel</MuiButton>
                    {permission.canModify && (
                        <MuiButton variant="contained" onClick={handleSaveSettings} disabled={isLoading} startIcon={isLoading && <i className="fa fa-spinner fa-spin"/>}>
                            {isLoading ? 'Saving...' : 'Save Settings'}
                        </MuiButton>
                    )}
                </Box>
            </Box>
        </MuiModal>
    );
}